import { timerFormatter } from './helper/timeFormatter';
// import { GameConfigs } from "../lib/globals/GameConfigs"
import HELPERS from '../lib/globals/helpers/Helpers';
import { EVENTS } from '../lib/constants';
import { GameConfigs } from '../lib/globals/GameConfigs';
import { NotificationView } from '../view/notifications/NotificationView';

let interval;
class TimerController {
	constructor(seconds) {
		this.seconds = seconds;
		// this.vc = vc
		// this.updateTimer(this.seconds);
		this.quest_claim = {
			claimed: false,
			activated: false,
			activated_item: 0,
			quest_data: null,
			step: false,
			status: '',
			leftBets: null
		};
	}

	updateTimer(time) {
		clearInterval(interval);
		let counter = 0;
		// this.vc.text = timerFormatter(time)
		interval = setInterval(() => {
			if (time - counter > 0) {
				counter++;
				// this.vc.text = timerFormatter(time - counter)
				HELPERS.dispatchCustomEvent(EVENTS.QUEST_UPDATE, {
					time: time - counter,
					formated: timerFormatter(time - counter)
				});

				GameConfigs.time_left = timerFormatter(time - counter);
			} else {
				if (!GameConfigs.bonusBuy) {
					window.connectionProvider.getQuest(
						JSON.stringify({
							service: 'quest',
							data: {}
						})
					);
					HELPERS.dispatchCustomEvent(EVENTS.QUEST_CLAIM, {
						quest_claim: this.quest_claim
					});
					GameConfigs.quest_claim = this.quest_claim;
					GameConfigs.quest_current = null;
					GameConfigs.quest_is_active = false;
					HELPERS.dispatchCustomEvent(EVENTS.QUEST_END, {
						end: true
					});
					if (
						GameConfigs.modal === 'quest' ||
						GameConfigs.modal === 'quest_claim' ||
						GameConfigs.modal === 'prompt' ||
						GameConfigs.modal === 'quest_prompt'
					) {
						GameConfigs.modal = 'notification';
						GameConfigs.notification = {
							code: 1112,
							msg: '',
							status: ''
						};
						HELPERS.dispatchCustomEvent(EVENTS.MODAL, {
							modal: 'notification'
						});
						GameConfigs.uiComponent.addView(NotificationView);
					}
					GameConfigs.updateQuest = true;
					clearInterval(interval);
				}
			}
		}, 1000);
	}
}

export default TimerController;
